import { reactive } from "vue";

const bus = reactive<Record<string, { nonce: number; payload?: unknown }>>({});

export function emitSignal<T>(key: string, payload?: T) {
  const entry = bus[key] ?? { nonce: 0 };
  bus[key] = { nonce: entry.nonce + 1, payload };
}

export function getSignalNonce(key: string) {
  return bus[key]?.nonce ?? 0;
}

export function getSignalPayload<T>(key: string) {
  return bus[key]?.payload as T | undefined;
}
